import React, { useMemo } from 'react'
import { Input } from '../../types/Customization'
import Card from '../../components/Card'
import { useTranslation } from 'react-i18next'
import { StoredTemplate } from '../../types/Individualization'

const InputDetails: React.FC<{
    inputs: Input[]
    activeTemplate: StoredTemplate | null
}> = ({ inputs, activeTemplate }) => {
    const { t } = useTranslation(['orders', 'customizer'])

    const groupBySpot = useMemo(() => {
        const grouped: {
            spot_id: string | number
            name: string
            inputs: Input[]
        }[] = []

        if (!activeTemplate) return grouped

        for (const spot of activeTemplate.spots) {
            const spotInputs = inputs.filter((i) => i.spot_id === spot.id)
            if (spotInputs.length > 0) {
                grouped.push({
                    spot_id: spot.id,
                    name: spot.name,
                    inputs: spotInputs,
                })
            }
        }

        return grouped
    }, [inputs, activeTemplate])

    return groupBySpot.length ? (
        <div className={'zr-d-flex zr-flex-column zr-gap-4 zr-mb-6'}>
            {groupBySpot.map((groupedSpot) => (
                <Card key={groupedSpot.spot_id} title={groupedSpot.name}>
                    <>
                        {groupedSpot.inputs.map((i) => (
                            <>
                                <div
                                    className={
                                        'zr-d-flex zr-flex-column zr-mt-3 zr-ml-3'
                                    }
                                >
                                    <small style={{ color: '#555' }}>
                                        {i.type === 'text' ||
                                        i.type === 'auto text'
                                            ? `Text (${i.font_family}, ${i.text_color.toUpperCase()})`
                                            : 'Bild'}
                                    </small>
                                    {i.type === 'text' ||
                                    i.type === 'auto text' ? (
                                        <span>{i.value}</span>
                                    ) : (
                                        <a href={i.value} download={true}>
                                            {' '}
                                            {i.label}
                                        </a>
                                    )}
                                </div>
                            </>
                        ))}
                    </>
                </Card>
            ))}
        </div>
    ) : (
        <div>{'Keine Benutzereingaben'}</div>
    )
}

export default InputDetails
